export class ShipmentSpec {
  id?: number;

  constructor(opts?: Partial<ShipmentSpec>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
  }
}
